module.exports = __webpack_public_path__ + "img/11.e9ba4ddc.png";